module.exports = __webpack_public_path__ + "static/media/gb.pictogram.e68237b2.svg";